export default __webpack_public_path__ + "static/media/snow.2fc59071.jpg";